import $ from 'jquery'

export default class MobileNav {
  constructor($el){
    this.$el = $el
    this.$expand = $($el).find('.global-header__nav__expand')
    this.$parentLink = $($el).find('.parent-link')
    this.$backLinks = $($el).find('.mobile-submenu-back')
    this.$subMenuToggle = $($el).find('.submenu-toggle')
    this.$mainNav = $($el).find('.global-header__nav')
    this.$burger = $($el).find('.global-header__burger')

    this.$burger.on('click', (e)=> {
      e.preventDefault()
      if ($(e.currentTarget).hasClass('is-active')) {
        this.closeNav()
      } else {
        this.openNav()
      }
    })

    this.$expand.on('click', (e)=> {
      if ($(e.currentTarget).hasClass('global-header__nav__expand--expanded')) {
        this.closeSubNav($(e.currentTarget))
      } else {
        this.openSubNav($(e.currentTarget))
      }
    })

    this.$parentLink.on('click', (e)=> {
      e.preventDefault()
      $('.global-header__bottom').toggleClass('submenu-open')
      $(e.target).next('.flyout').addClass('active')
    })

    this.$backLinks.on('click', (e)=> {
      e.preventDefault()
      $('.global-header__bottom').toggleClass('submenu-open')
      // Match duration of menu animation
      setTimeout( function() {
        $(e.target).parents('.flyout').removeClass('active')
        $('.flyout__column').removeClass('open')
      }, 250)
    })

    this.$subMenuToggle.on('click', (e)=> {
      e.preventDefault()
      if ( !$(e.target).parents('.flyout__column').hasClass('open') ) {
        $('.flyout__column').removeClass('open')
      }
      $(e.target).parents('.flyout__column').toggleClass('open')
    })


  }
  closeNav() {
    this.$burger.removeClass('is-active')
    this.$mainNav.hide()
    $('body').removeClass('navigation-open')
    $(this).parent('li').removeClass('global-header__nav__item--open')
  }
  closeSubNav($el) {
    $el.removeClass('global-header__nav__expand--expanded')
    $el.closest('li').removeClass('global-header__nav__item--open')
    $el.siblings('ul').hide()
  }
  openNav() {
    this.$burger.addClass('is-active')
    this.$mainNav.show()
    $('body').addClass('navigation-open')
    $(this).parent('li').addClass('global-header__nav__item--open')
  }
  openSubNav($el) {
    $el.addClass('global-header__nav__expand--expanded')
    $el.closest('li').addClass('global-header__nav__item--open')
    $el.siblings('ul').show()
  }
}
